import { LoadingState } from "@app/root-store/api-result.state";
import { createReducer, on } from "@ngrx/store";
import { EntityActions } from "../actions";
import { EntityState, initialEntityState } from "../entity.state";

export const reducer = createReducer(
    initialEntityState,
    on(
        EntityActions.loadSet.request,
        EntityActions.updateSet.request,
        EntityActions.createSet.request,
        EntityActions.deleteSet.request,
        (state): EntityState => ({
            ...state,
            entities: {
                ...state.entities,
                callState: LoadingState.loading,
            },
        })
    ),
    on(
        EntityActions.updateSet.success,
        EntityActions.createSet.success,
        (state, { entity }): EntityState => ({
            ...state,
            entities: {
                ...state.entities,
                result: {
                    ...state.entities.result,
                    [entity.id]: {
                        ...state.entities.result?.[entity.id],
                        ...entity,
                    },
                },
                callState: LoadingState.loaded,
            },
        })
    ),
    on(
        EntityActions.removeEntityAddressSet.success,
        (state, { entity }): EntityState => ({
            ...state,
            entities: {
                ...state.entities,
                result: {
                    ...state.entities.result,
                    [entity.id]: {
                        ...state.entities.result[entity.id],
                        ...entity,
                        shippingAddress: null,
                    },
                },
                callState: LoadingState.loaded,
            },
        })
    ),
    on(EntityActions.deleteSet.success, (state, { entity }): EntityState => {
        const entities = state.entities.result;
        delete entities[entity.id];
        return {
            ...state,
            entities: {
                ...state.entities,
                result: entities,
                callState: LoadingState.loaded,
            },
        };
    }),
    on(EntityActions.loadSet.success, (state, { entities }) => ({
        ...state,
        entities: { result: entities, callState: LoadingState.loaded },
    })),
    on(EntityActions.clearEntityState, _ => initialEntityState)
);
